<template>
  <div>
    <div class="nav-bar-container">
      <div class="nav-bar">
        <a @click="navBack()">
          &lt; {{ $i18n.t( 'back') }}
        </a>
      </div>
    </div>

    <div class="header-container">
      <div class="header">
        <span class="notice-header">
          {{ title }}
        </span>
        <hr style="max-width: 100%">
        <span class="notice-note">
          {{ notice }}
        </span>
      </div>
    </div>
    <div class="form-wrapper">
      <form
        class="reset-pwd-form"
        @submit.prevent
      >
        <label>
          <span class="required-flag">{{ $t('username') }}({{ $t('general.emailAddress') }})</span>
          <input
            class="text-input"
            type="email"
            v-model="email"
          >
        </label>

        <div class="right-btns">
          <button
            type="button"
            class="btn btn--darkblue  radius round"
            id="forgotpwd-form-cancel"
            @click="navBack()"
          >{{ $t('action.cancel') }}</button>
          <button
            class="btn btn--orange  radius round"
            id="forgotpwd-form-send"
            @click="send()"
            :disabled="!emailValid || !enableSend"
          >{{ $t('action.send') }}</button>
        </div>
      </form>
    </div>
    <HKLModal
      ref="confirmModal"
      :hasCancelBtn="false"
      :title="confirmHint"
      :closable="true"
      :afterClose="navToLogin"
    />
    <HKLModal
      ref="rejectModal"
      :closable="true"
      :hasCancelBtn="false"
    >
      <template slot="title">
        <pre>{{ $t('settings.password.emailNotExist') }}</pre>
      </template>
    </HKLModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { email } from '@/utils/regex'
import HTTP, {USER_DOMAIN_HEADER} from '@/utils/http'
import Status from 'http-status-codes'
import notification from '@/utils/notification'
import HKLModal from './Modal/HKLModal.vue'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { getRegionsAndSetCurrent, switchLangByRegion } from '@/pages/utils'

export default {
  components: {
    HKLModal,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    notice: {
      type: String,
      default: '',
    },
    confirmHint: {
      type: String,
      default: '',
    },
    requestPath: {
      type: String,
      default: '',
    },

  },
  setup () {
    const { modal: confirmModal, open: openConfirmModal } = useRefModal()
    const { modal: rejectModal, open: openRejectModal } = useRefModal()

    return {
      confirmModal,
      openConfirmModal,
      rejectModal,
      openRejectModal,
    }
  },

  data () {
    return {
      email: null,
      enableSend: true,
    }
  },
  computed: {
    ...mapGetters('regions', ['publicPathLastSelectedRegion']),
    emailValid () {
      return email.test(this.email)
    },
  },
  async mounted () {
    const regionName = this.$router.currentRoute.query.region
    if (regionName) {
      await getRegionsAndSetCurrent(regionName)
      switchLangByRegion(regionName)
    } else {
      this.updateCurrentRegion(this.publicPathLastSelectedRegion.name)
    }
  },
  methods: {
    ...mapActions('regions', ['updateCurrentRegion']),
    navBack () {
      this.$router.goBack()
    },
    async send () {
      try {
        this.enableSend = false
        const query = this.$router.currentRoute.query
        const domain = query && query.domain
        const domainHeader = { headers: { [USER_DOMAIN_HEADER]: domain } }
        await HTTP.post(`/${this.requestPath}`, { username: this.email }, domainHeader)
        this.openConfirmModal()
      } catch (err) {
        const response = err.response
        if (response.status === Status.NOT_FOUND) {
          this.openConfirmModal()
        } else if (response.status === Status.FORBIDDEN) {
          this.openRejectModal()
        } else {
          notification.handleResponseError(err)
        }
      }
      this.enableSend = true
    },
    navToLogin () {
      this.$router.push({ name: 'publicLogin' })
    },
  },

}
</script>

    <style lang="scss" scoped>
    @import '~styles/popup';

    .form-wrapper {
      min-height: 300px;
      position: relative;
    }
    .header-container {
      max-width: 1440px;
      margin: 0 auto;
    }
    .nav-bar {
      padding: 15px 24px;
      width: 100%;
      background: #EBEBEB;
      a {
        color: #0C3A58;
        font-size: 12px;
      }
    }

    .header {
      margin-top: 20px;
    }

    .notice-header {
      font-family: Georgia;
      font-weight: bold;
      font-size: 24px;
      padding-left: 20px;
    }

    .notice-note {
      font-family: Verdana;
      font-size: 16px;
      padding-left: 20px;
    }

    .reset-pwd-form {
      width: 330px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    label {
      font-family: Verdana;
      font-size: 16px;
      color: #0C3A58;
      .required-flag:after {
        color: #E49405;
        content: '*';
      }
    }

    .text-input {
      color: #0C3A58;
    }

    .right-btns {
      margin-top: 16px;
      float: right;
      .btn {
        margin-left: 16px;
      }
    }

    </style>
    <style scoped src="styles/dashboard/style.scss"></style>
